module.exports = __webpack_public_path__ + "static/media/ok.204ca8ef.png";